import { CardDataClass, PlayerDataClass } from "../typings"

export function sortPlayerCards(
  player: PlayerDataClass,
  trumpSuit: CardDataClass["cardSuit"]
): void {
  player.cards.move((cards) => {
    // Implement bubble sort using direct swaps
    for (let i = 0; i < cards.length; i++)
      for (let j = 0; j < cards.length - i - 1; j++) {
        const a = cards[j]
        const b = cards[j + 1]

        let shouldSwap = false

        if (
          (a.cardSuit === trumpSuit && b.cardSuit === trumpSuit) ||
          (a.cardSuit !== trumpSuit && b.cardSuit !== trumpSuit)
        )
          // Same suit type (both trump or both non-trump)
          shouldSwap = a.cardPower > b.cardPower
        else if (a.cardSuit === trumpSuit && b.cardSuit !== trumpSuit)
          // a is trump, b is not - trump cards go after non-trump
          shouldSwap = true

        // If a is non-trump and b is trump, we don't swap

        if (shouldSwap) {
          // Swap the elements
          ;[cards[j], cards[j + 1]] = [cards[j + 1], cards[j]]
        }
      }
  })
}
